import { DictionaryAutocomplete, useStaticListSource } from '@eas/common-web';
import { ExportTag } from '../../enums';

export function useExportTag() {
  return useStaticListSource<DictionaryAutocomplete>([
    { id: ExportTag.INTERNAL, name: 'Interní' },

    { id: ExportTag.EXPORT_TEMPLATES_GRID, name: 'Přehled tiskových šablon' },
    { id: ExportTag.EXPORT_TEMPLATES_DETAIL, name: 'Detail tiskové šablony' },

    { id: ExportTag.EXPORT_REQUESTS_GRID, name: 'Přehled tiskové fronty' },
    {
      id: ExportTag.EXPORT_REQUESTS_DETAIL,
      name: 'Detail záznamu tiskové fronty',
    },
  ]);
}

/* export function useReportPermission() {
  return useStaticListSource<DictionaryAutocomplete>([
    { id: Permission.Default.ADMINISTRATOR, name: 'Administrátor' },
    { id: Permission.Default.INTERNAL, name: 'Operátor' },
  ]);
}
 */
